<template>
  <div>
    <div class="header mb-8">회원 가입 완료 🙌</div>
    <div class="vertical-line mb-6"></div>
    <div class="mb-10">
      매장에 딱 맞는 체험단 마케팅 컨설팅을 위해 <br />
      <span class="font-weight-bold">광고 정보를 입력</span>해주세요! <br /><br />
      사장님께 필요한 맞춤형 광고를 셋팅할 수 있어요.
    </div>
    <v-btn class="submit mb-4" text outlined @click="$router.push(`/regads?${queryParams}`)">광고정보 입력하기 ></v-btn>
  </div>
</template>

<script>
export default {
  name: 'RegisterDone',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    queryParams() {
      const defaultParams = `type=${this.type}&companyName=${this.companyName}`;
      const optionalParams = this.x && this.y ? `&x=${this.x}&y=${this.y}` : '';
      return `${defaultParams}${optionalParams}`;
    },
  },

  data() {
    return {
      type: this.$route.query.type || this.form.type || '',
      companyName: this.$route.query.companyName || this.form.name || '',
      x: this.$route.query.x || this.form.x || '',
      y: this.$route.query.y || this.form.y || '',
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/form.scss';

.header {
  color: #000;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.vertical-line {
  width: 100%;
  height: 1px;
  background-color: #c2c2c2;
  opacity: 0.3;
}

.content {
  color: #3a3a3a;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}
</style>
